var appInstasearch = document.querySelector('#app-instasearch');

if ( appInstasearch ) {
	var instasearchApp = new Vue({
		
		el: appInstasearch,
		
		data: { 
			authorNameSearchString: "",
			photoFeed: null
		},
		
		mounted() {
			axios
				.get('/static/data/locations.json')
				.then(response => {
					this.photoFeed = response.data;
				})
				.catch(error => console.log(error))
		},
		
		 computed: {
	        
	        filteredPhotoFeed: function () {
				
	            var photos = this.photoFeed;
	            var authorNameSearchString = this.authorNameSearchString;

	            if(!authorNameSearchString){
	                return '';//photos;
	            }

	            var searchString = authorNameSearchString.trim().toLowerCase();

	            photos = photos.filter(function(item){
	                if((item.terms.toLowerCase().indexOf(authorNameSearchString) !== -1) || (item.tags.toLowerCase().indexOf(authorNameSearchString) !== -1)){
	                    return item;
	                }
	            })

	            return photos;
	        }
		 }
	});
}